/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Addons_EyebrowInputs */

const tr_pricing_addons_eyebrow = /** @type {(inputs: Pricing_Addons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EK KREDİ PAKETLERİ`)
};

const en_pricing_addons_eyebrow = /** @type {(inputs: Pricing_Addons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXTRA CREDIT PACKAGES`)
};

const de_pricing_addons_eyebrow = /** @type {(inputs: Pricing_Addons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZUSÄTZLICHE CREDIT-PAKETE`)
};

const ru_pricing_addons_eyebrow = /** @type {(inputs: Pricing_Addons_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДОПОЛНИТЕЛЬНЫЕ ПАКЕТЫ КРЕДИТОВ`)
};

/**
* | output |
* | --- |
* | "EXTRA CREDIT PACKAGES" |
*
* @param {Pricing_Addons_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_addons_eyebrow = /** @type {((inputs?: Pricing_Addons_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Addons_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_addons_eyebrow(inputs)
	if (locale === "de") return de_pricing_addons_eyebrow(inputs)
	if (locale === "ru") return ru_pricing_addons_eyebrow(inputs)
	return tr_pricing_addons_eyebrow(inputs)
});